import { render, staticRenderFns } from "./informacionedicion_editoriales.vue?vue&type=template&id=7db22114"
import script from "./informacionedicion_editoriales.vue?vue&type=script&lang=js"
export * from "./informacionedicion_editoriales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports